import { apiService } from "./api";

export interface PublicCmsSettings {
  facebookUrl: string | null;
  instagramUrl: string | null;
  twitterUrl: string | null;
  youtubeUrl: string | null;
  whatsappNumber: string | null;
  email: string | null;
  storeLocation: string | null;
  homePageImage: string | null;
  homePageTitle: string | null;
  homePageDescription: string | null;
  homePageSubtitle: string | null;
  siteName: string | null;
  siteDescription: string | null;
  facebookPixelId: string | null;
}

export const cmsService = {
  getPublicSettings: async (): Promise<PublicCmsSettings> => {
    return await apiService.get<PublicCmsSettings>("/cms/public");
  },
};

